<!-- START NAVBAR -->
<nav
  class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark"
  id="navbar"
  (window:scroll)="windowScroll()"
>
  <div class="container">
    <div class="navbar-container">
      <div class="logo-navbar">
        <img
          src="./assets/images/logo-portal.png"
          alt="logo portal de compras publicas"
          class="logo-portal"
        />
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
        (click)="toggleMenu()"
      >
        <span class="ti-menu"></span>
      </button>
      <div class="collapse navbar-collapse navbar-menu" id="navbarCollapse">
        <ul class="navbar-nav mx-auto" id="navbar-navlist">
          <li class="nav-item" [ngClass]="{ active: currentSection === 'pricing' }">
            <a (click)="scrollToSection('pricing', $event)" class="nav-link" href="#pricing"
              >FACILIDADES</a
            >
          </li>
          <li class="nav-item" [ngClass]="{ active: currentSection === 'contact' }">
            <a (click)="scrollToSection('contact', $event)" class="nav-link" href="#contact"
              >COMO FUNCIONA</a
            >
          </li>
          <li class="nav-item" [ngClass]="{ active: currentSection === 'features' }">
            <a (click)="scrollToSection('features', $event)" class="nav-link" href="#features"
              >O PORTAL</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
<!-- END NAVBAR -->
<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)">
  <!-- START HOME -->
  <div class="background-color-box">
    <section class="section bg-home" id="home">
      <div class="container">
        <div class="container-content-index">
          <div class="text-container">
            <div class="title-wrapper">
              <h1 class="title-header">
                Receba avisos de licitação gratuitos com a ajuda de nossa Inteligência Artificial
              </h1>
            </div>
            <div class="index-text-wrapper">
              <p class="text-muted home-subtitle mt-4 mb-0 text-header">
                São mais de 400 novas e exclusivas oportunidades de vender para o governo todos os
                dias. Não perca nenhuma oportunidade. Aumente a sua chance de vencer licitações e
                alavancar o seu faturamento.
              </p>
            </div>
            <div class="mt-4 btn-wrapper">
              <a (click)="handleClick()" class="btn btn-index btn-index-new" href="#navbar"
                >QUERO RECEBER OPORTUNIDADES</a
              >
            </div>
          </div>
          <div class="form-container" id="form">
            <div class="navigation-header">
              <div>
                <button
                  class="btn-left"
                  *ngIf="showButton"
                  (click)="onBackForm()"
                  [disabled]="stepSucess"
                >
                  <img src="./assets/images/arrow-left.svg" alt="seta esquerda" />
                </button>
              </div>
              <div class="navigation-title">
                <p class="form-title-new form-title">Aviso de Licitações Gratuito</p>
                <div class="count">{{ stepForm }}/3</div>
              </div>
              <div>
                <button
                  class="btn-right"
                  *ngIf="showButton"
                  (click)="onNext()"
                  [disabled]="
                    !canAdvance || form2.get('subCategoriaFornecimento').value?.length == 0
                  "
                >
                  <img [src]="advanceIcon" alt="seta direita" />
                </button>
              </div>
            </div>

            <!-- STEP 1 -->
            <form
              method="post"
              [formGroup]="form1"
              class="label-container"
              *ngIf="stepForm == 1"
              (ngSubmit)="onNext()"
            >
              <div class="toastr-container" *ngIf="toastrsValidate && toastrsValidate.length > 0">
                <div *ngFor="let toastr of toastrsValidate">
                  <app-toastr
                    [toastrInfo]="toastr"
                    [autoDestroy]="false"
                    (clearToastr)="clearToastr($event)"
                  ></app-toastr>
                </div>
              </div>
              <div class="pessoa-container">
                <div class="radio-group">
                  <div
                    class="radio-options"
                    [ngClass]="{ selected: selectedTipoPessoa === 'juridica' }"
                  >
                    <input
                      type="radio"
                      id="juridica"
                      name="tipoPessoa"
                      value="juridica"
                      formControlName="tipoPessoa"
                      (change)="updateFormFields()"
                    />
                    <label for="juridica" class="text-label-pessoa">Pessoa Jurídica</label>
                  </div>
                  <div
                    class="radio-options"
                    [ngClass]="{ selected: selectedTipoPessoa === 'fisica' }"
                  >
                    <input
                      type="radio"
                      id="fisica"
                      name="tipoPessoa"
                      value="fisica"
                      formControlName="tipoPessoa"
                      (change)="updateFormFields()"
                    />
                    <label for="fisica" class="text-label-pessoa">Pessoa Física</label>
                  </div>
                </div>
              </div>
              <div class="controls-new">
                <div class="input-row">
                  <div class="input-wrapper">
                    <label for="nome" class="text-label">Seu nome</label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      class="text-input form-control registration-input-box"
                      formControlName="nome"
                      aria-label="nome"
                      (change)="onGenericFieldChange()"
                      placeholder="Digite seu nome aqui"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('nome').invalid &&
                          (form1.get('nome').touched || form1.get('nome').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('nome').invalid &&
                        (form1.get('nome').dirty || form1.get('nome').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div *ngIf="form1.get('nome').hasError('required')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div
                        *ngIf="
                          form1.get('nome').hasError('minlength') ||
                          form1.get('nome').hasError('pattern')
                        "
                        class="alert-new"
                      >
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Informação inválida. Tente novamente</small>
                      </div>
                    </div>
                  </div>

                  <div class="input-wrapper">
                    <label for="email" class="text-label">E-mail</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      aria-label="email"
                      class="text-input form-control registration-input-box"
                      formControlName="email"
                      (change)="onGenericFieldChange()"
                      placeholder="Digite seu e-mail aqui"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('email').invalid &&
                          (form1.get('email').touched || form1.get('email').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('email').invalid &&
                        (form1.get('email').dirty || form1.get('email').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div class="alert-new" *ngIf="form1.get('email').hasError('required')">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div *ngIf="form1.get('email').hasError('email')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Informação inválida. Tente novamente</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-row" *ngIf="form1.get('tipoPessoa').value === 'juridica'">
                  <div class="input-wrapper">
                    <label for="cnpj" class="text-label">CNPJ</label>
                    <input
                      type="text"
                      id="cnpj"
                      aria-label="cnpj"
                      name="cnpj"
                      class="text-input form-control registration-input-box"
                      (change)="onGenericFieldChange()"
                      placeholder="00.000.000/0000-00"
                      [mask]="'00.000.000/0000-00'"
                      formControlName="cnpj"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('cnpj').invalid &&
                          (form1.get('cnpj').touched || form1.get('cnpj').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('cnpj').invalid &&
                        (form1.get('cnpj').dirty || form1.get('cnpj').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div *ngIf="form1.get('cnpj').hasError('required')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div *ngIf="hasCNPJError()" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Informação inválida. Tente novamente</small>
                      </div>
                    </div>
                  </div>

                  <div class="input-wrapper">
                    <label for="razaoSocial" class="text-label">Razão Social</label>
                    <input
                      type="text"
                      id="razaoSocial"
                      aria-label="razaoSocial"
                      name="razaoSocial"
                      class="text-input form-control registration-input-box"
                      (change)="onGenericFieldChange()"
                      formControlName="razaoSocial"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('razaoSocial').invalid &&
                          (form1.get('razaoSocial').touched || form1.get('razaoSocial').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('razaoSocial').invalid &&
                        (form1.get('razaoSocial').dirty || form1.get('razaoSocial').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div class="alert-new" *ngIf="form1.get('razaoSocial').hasError('required')">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div *ngIf="form1.get('razaoSocial').hasError('minlength')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Razão Social inválida.</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-row" *ngIf="form1.get('tipoPessoa').value === 'fisica'">
                  <div class="input-wrapper">
                    <label for="whatsapp" class="text-label">Whatsapp</label>
                    <input
                      type="text"
                      id="whatsapp"
                      aria-label="whatsapp"
                      name="whatsapp"
                      class="text-input form-control registration-input-box"
                      (change)="onGenericFieldChange()"
                      mask="(00) 0 0000-0000"
                      placeholder="(00) 00000-0000"
                      formControlName="whatsapp"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('whatsapp').invalid &&
                          (form1.get('whatsapp').touched || form1.get('whatsapp').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('whatsapp').invalid &&
                        (form1.get('whatsapp').dirty || form1.get('whatsapp').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div *ngIf="form1.get('whatsapp').hasError('required')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div *ngIf="form1.get('whatsapp').hasError('pattern')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Informação inválida. Tente novamente</small>
                      </div>
                    </div>
                  </div>

                  <div class="input-wrapper" *ngIf="form1.get('tipoPessoa').value === 'fisica'">
                    <label for="cpf" class="text-label">CPF</label>
                    <input
                      type="text"
                      id="cpf"
                      aria-label="cpf"
                      name="cpf"
                      class="text-input form-control registration-input-box"
                      (change)="onGenericFieldChange()"
                      placeholder="000.000.000-00"
                      [mask]="'000.000.000-00'"
                      formControlName="cpf"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('cpf').invalid &&
                          (form1.get('cpf').touched || form1.get('cpf').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('cpf').invalid &&
                        (form1.get('cpf').dirty || form1.get('cpf').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div class="alert-new" *ngIf="form1.get('cpf').hasError('required')">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div class="alert-new" *ngIf="hasCPFError()">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Informação inválida. Tente novamente</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-row">
                  <div class="input-wrapper">
                    <label for="" class="text-label">Estado</label>
                    <ng-select
                      class="text-input form-control registration-input-box"
                      required
                      placeholder="UF"
                      name="estado"
                      [items]="estados"
                      bindLabel="sigla"
                      [dropdownPosition]="'bottom'"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('estado').invalid &&
                          (form1.get('estado').touched || form1.get('estado').dirty),
                      }"
                      (change)="onEstadoChange(form1.get('estado').value?.sigla)"
                      formControlName="estado"
                    >
                    </ng-select>
                    <div
                      *ngIf="
                        form1.get('estado').invalid &&
                        (form1.get('estado').dirty || form1.get('estado').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div *ngIf="form1.get('estado').hasError('required')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                    </div>
                  </div>

                  <div class="input-wrapper">
                    <label for="" class="text-label">Município</label>
                    <ng-select
                      class="text-input form-control mb-2 registration-input-box"
                      (change)="onGenericFieldChange()"
                      required
                      placeholder="Município"
                      [dropdownPosition]="'bottom'"
                      name="municipio"
                      [items]="municipios"
                      formControlName="municipio"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('municipio').invalid &&
                          (form1.get('municipio').touched || form1.get('municipio').dirty),
                      }"
                    >
                    </ng-select>
                    <div
                      *ngIf="
                        form1.get('municipio').invalid &&
                        (form1.get('municipio').dirty || form1.get('municipio').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div *ngIf="form1.get('municipio').hasError('required')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="input-row" *ngIf="form1.get('tipoPessoa').value === 'juridica'">
                  <div class="input-wrapper">
                    <label for="whatsapp" class="text-label">Whatsapp</label>
                    <input
                      type="text"
                      id="whatsapp"
                      aria-label="whatsapp"
                      name="whatsapp"
                      class="text-input form-control registration-input-box"
                      (change)="onGenericFieldChange()"
                      mask="(00) 0 0000-0000"
                      placeholder="(00) 00000-0000"
                      formControlName="whatsapp"
                      [ngClass]="{
                        'has-invalid':
                          form1.get('whatsapp').invalid &&
                          (form1.get('whatsapp').touched || form1.get('whatsapp').dirty),
                      }"
                    />
                    <div
                      *ngIf="
                        form1.get('whatsapp').invalid &&
                        (form1.get('whatsapp').dirty || form1.get('whatsapp').touched)
                      "
                      class="form-alert-error-wrapper"
                    >
                      <div *ngIf="form1.get('whatsapp').hasError('required')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error"
                          >Este campo é obrigatório. Complete para prosseguir.</small
                        >
                      </div>
                      <div *ngIf="form1.get('whatsapp').hasError('pattern')" class="alert-new">
                        <img src="assets/images/alert-error.svg" alt="Icon" />
                        <small class="form-alert-error">Informação inválida. Tente novamente</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="alert-required-new">
                <p>-> Todos os campos devem ser preenchidos.</p>
              </div>
              <div class="btn-group-new">
                <button
                  type="submit"
                  class="button-form-page"
                  id="button-submit"
                  [disabled]="form1.invalid"
                >
                  Próximo
                </button>
              </div>
            </form>

            <!-- STEP 2 -->
            <form
              method="post"
              [formGroup]="form2"
              class="label-container"
              *ngIf="stepForm == 2"
              (ngSubmit)="onNext()"
            >
              <label for="" class="text-step2-new"
                >Deseja receber oportunidades para todo o Brasil, ou só para o seu Estado?</label
              >
              <div class="row-options-new">
                <div class="toggle-selector-container radio-options-new">
                  <div class="toggle-selector-wrapper">
                    <!-- Opção 1: Apenas meu Estado -->
                    <label class="choice-toggle-item">
                      <input
                        type="radio"
                        name="oportunidadesBrasil"
                        value="Apenas meu Estado"
                        formControlName="oportunidadesBrasil"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Apenas meu estado</span>
                    </label>

                    <!-- Opção 2: Todo o Brasil -->
                    <label class="choice-toggle-item">
                      <input
                        type="radio"
                        name="oportunidadesBrasil"
                        value="Todo o Brasil"
                        formControlName="oportunidadesBrasil"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Todo Brasil</span>
                    </label>
                  </div>
                </div>
              </div>
              <label for="" class="text-step2-new"
                >Escolha a linha de fornecimento do seu negócio:</label
              >
              <div class="align-select">
                <div class="align-row-new">
                  <ng-select
                    class="text-input form-control mb-2 registration-input-box"
                    (change)="onGenericFieldChange()"
                    required
                    placeholder="Selecione uma categoria"
                    name="categoriaFornecimento"
                    [items]="categorias"
                    bindLabel="nomeGrupo"
                    [ngClass]="{
                      'has-invalid':
                        form2.get('categoriaFornecimento').invalid &&
                        (form2.get('categoriaFornecimento').touched ||
                          form2.get('categoriaFornecimento').dirty),
                    }"
                    (change)="
                      onCategoriaChange(form2.get('categoriaFornecimento').value?.CodigoCategoria)
                    "
                    formControlName="categoriaFornecimento"
                  >
                  </ng-select>
                  <div
                    *ngIf="
                      form2.get('categoriaFornecimento').invalid &&
                      (form2.get('categoriaFornecimento').dirty ||
                        form2.get('categoriaFornecimento').touched)
                    "
                    class="form-alert-error-wrapper"
                  >
                    <div
                      *ngIf="form2.get('categoriaFornecimento').hasError('required')"
                      class="alert-new"
                    >
                      <img src="assets/images/alert-error.svg" alt="Icon" />
                      <small class="form-alert-error"
                        >Este campo é obrigatório. Complete para prosseguir.</small
                      >
                    </div>
                  </div>
                </div>
              </div>
              <label for="" class="text-step2-new"
                >Digite a <span class="text-label-bold">palavra-chave</span> do produto/serviço que
                você fornece e nossa IA te ajudará a encontrar a correspondência.
              </label>
              <span class="text-step2-new-descr"
                >Faça uma busca por vez, pesquise quantas vezes quiser.</span
              >
              <div class="align-search-new">
                <div class="search-field-container">
                  <input
                    type="text"
                    (change)="onGenericFieldChange()"
                    (keypress)="onKeyPress($event)"
                    name="palavraPesquisaGpt"
                    class="text-input form-control search-box-new registration-input-box"
                    formControlName="palavraPesquisaGpt"
                    placeholder="Digite aqui a sua palavra-chave"
                  />
                  <button
                    type="button"
                    class="btn button-search-form btn-search-new"
                    (click)="handlePesquisarGptClick()"
                    [disabled]="form2.get('palavraPesquisaGpt').value?.length < 4"
                  >
                    <img
                      src="./assets/images/ico-lupa-branco.png"
                      class="searching-img"
                      alt="lupa"
                      *ngIf="!gptIsLoading"
                    />
                    <img
                      src="./assets/images/seta-redonda2.svg"
                      class="searching-img-animated"
                      alt="gif pesquisando"
                      *ngIf="gptIsLoading"
                    />
                  </button>
                </div>
              </div>
              <div class="basic-search-wrapper">
                <label for="" class="basic-search" (click)="handleGenericSearchClick()"
                  >Ver todas as opções sem filtro da IA</label
                >
              </div>

              <label
                for=""
                class="text-step2-new"
                *ngIf="
                  subCategorias?.length != 0 ||
                  form2.get('subCategoriaFornecimento').value?.length != 0
                "
                >Escolha a(s) subcategoria(s) que mais encaixam com o seu negócio:
              </label>
              <div
                class="align-select"
                *ngIf="
                  subCategorias?.length != 0 ||
                  form2.get('subCategoriaFornecimento').value?.length != 0
                "
              >
                <ng-select
                  class="text-input form-control mb-2 h-auto registration-input-box"
                  #listSubCategoria
                  (change)="onGenericFieldChange()"
                  [dropdownPosition]="'bottom'"
                  required
                  [ngClass]="{
                    'has-invalid':
                      form2.get('subCategoriaFornecimento').invalid &&
                      (form2.get('subCategoriaFornecimento').touched ||
                        form2.get('subCategoriaFornecimento').dirty),
                  }"
                  placeholder="Selecione uma subcategoria"
                  name="subCategoriaFornecimento"
                  [items]="subCategorias"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  bindLabel="codigoMaterial"
                  formControlName="subCategoriaFornecimento"
                >
                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                    <input
                      id="item-{{ index }}"
                      type="checkbox"
                      class="select-check"
                      [checked]="item$.selected"
                    />
                    {{ item.gender | uppercase }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input
                      id="item-{{ index }}"
                      type="checkbox"
                      class="select-check"
                      [checked]="item$.selected"
                    />
                    {{ item.codigoMaterial }}
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (subCategorias?.length != 0 ||
                      form2.get('subCategoriaFornecimento').value?.length != 0) &&
                    form2.get('subCategoriaFornecimento').invalid &&
                    (form2.get('subCategoriaFornecimento').dirty ||
                      form2.get('subCategoriaFornecimento').touched)
                  "
                  class="form-alert-error-wrapper"
                >
                  <div
                    *ngIf="form2.get('subCategoriaFornecimento').hasError('required')"
                    class="alert-new"
                  >
                    <img src="assets/images/alert-error.svg" alt="Icon" />
                    <small class="form-alert-error"
                      >Este campo é obrigatório. Complete para prosseguir.</small
                    >
                  </div>
                </div>
              </div>
              <div class="alert-required-new">
                <p>-> Todos os campos devem ser preenchidos.</p>
              </div>
              <div class="btn-group-new">
                <button
                  type="submit"
                  class="button-form-page"
                  id="button-submit"
                  [disabled]="
                    form2.invalid || form2.get('subCategoriaFornecimento').value?.length == 0
                  "
                >
                  Próximo
                </button>
              </div>
            </form>

            <!-- STEP 3 -->
            <form
              method="post"
              [formGroup]="form3"
              class="label-container"
              *ngIf="stepForm == 3 && !stepSucess"
              (ngSubmit)="onSubmit()"
            >
              <div class="toastr-container" *ngIf="toastrs && toastrs.length > 0">
                <div *ngFor="let toastr of toastrs">
                  <app-toastr
                    [toastrInfo]="toastr"
                    [autoDestroy]="false"
                    (clearToastr)="clearToastr($event)"
                  ></app-toastr>
                </div>
              </div>
              <label for="" class="text-step3-new">Eu sou:</label>
              <div class="row-options-new">
                <div class="toggle-selector-container radio-options-new">
                  <div class="toggle-selector-wrapper">
                    <!-- Opção: Empresário -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="euSou"
                        value="Empresario"
                        formControlName="euSou"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Empresário</span>
                    </label>

                    <!-- Opção: Consultor -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="euSou"
                        value="Consultor"
                        formControlName="euSou"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Consultor</span>
                    </label>

                    <!-- Opção: Analista -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="euSou"
                        value="Analista"
                        formControlName="euSou"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Analista</span>
                    </label>

                    <!-- Opção: Outro -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="euSou"
                        value="Outro"
                        formControlName="euSou"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Outro</span>
                    </label>
                  </div>
                </div>
              </div>
              <label for="" class="text-step3-new"
                >Você ou sua empresa já participou de licitações?</label
              >
              <div class="row-options-new">
                <div class="toggle-selector-container radio-options-new">
                  <div class="toggle-selector-wrapper">
                    <!-- Opção: Sim -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="licitante"
                        value="true"
                        formControlName="licitante"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Sim</span>
                    </label>

                    <!-- Opção: Não -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="licitante"
                        value="false"
                        formControlName="licitante"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Não</span>
                    </label>
                  </div>
                </div>
              </div>

              <label for="" class="text-step3-new"
                >Tem interesse em cursos gratuitos de licitação?</label
              >
              <div class="row-options-new">
                <div class="toggle-selector-container radio-options-new">
                  <div class="toggle-selector-wrapper">
                    <!-- Opção: Sim -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="interesseCursos"
                        value="true"
                        formControlName="interesseCursos"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Sim</span>
                    </label>

                    <!-- Opção: Não -->
                    <label class="choice-toggle-item valid-item">
                      <input
                        type="radio"
                        name="interesseCursos"
                        value="false"
                        formControlName="interesseCursos"
                        (change)="onGenericFieldChange()"
                      />
                      <span class="choice-indicator">
                        <svg
                          class="choice-checkmark"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </span>
                      <span class="choice-label">Não</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="alert-required-new">
                <p>-> Todos os campos devem ser preenchidos.</p>
              </div>
              <label class="privacy-agreement-container">
                <input type="checkbox" class="privacy-checkbox-input" formControlName="termos" />
                <span class="privacy-checkbox-custom">
                  <svg
                    class="privacy-checkbox-checkmark"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <polyline points="20,6 9,17 4,12"></polyline>
                  </svg>
                </span>
                <span class="privacy-agreement-text">
                  Aceitar
                  <a
                    href="https://www.portaldecompraspublicas.com.br/sobre/aviso-privacidade"
                    class="privacy-policy-link"
                    target="_blank"
                  >
                    política de privacidade
                  </a>
                </span>
              </label>
              <div class="btn-group-new">
                <button
                  type="submit"
                  class="button-form-page"
                  id="gtm-sucesso-criacao-usuario"
                  [disabled]="form3.invalid"
                  *ngIf="!submitIsLoading"
                >
                  Enviar
                </button>
                <button
                  type="submit"
                  class="button-form-page"
                  *ngIf="submitIsLoading"
                >
                  <img
                    src="./assets/images/seta-redonda2.svg"
                    class="searching-img-animated"
                    alt="gif pesquisando"
                  />
                </button>
              </div>
            </form>
            <div class="step3success-container" *ngIf="stepSucess">
              <div class="step3success-content-area">
                <div class="step3success-icon-container">
                  <img src="./assets/images/check.gif" alt="check icon" />
                </div>
                <h2 class="step3success-main-title">Cadastro realizado com sucesso!</h2>
                <p class="step3success-subtitle">
                  Enviamos para o email cadastrado as informações<br />
                  para seu primeiro acesso.
                </p>
                <p class="step3success-subtitle">
                  Você será redirecionado para a página de pesquisa<br />
                  de processos em:
                </p>
                <div class="step3success-timer">
                  <p>{{ redirectCountdown }}s</p>
                </div>
              </div>
              <div class="step3success-action-area">
                <div class="btn-group-new">
                  <button
                    class="step3success-primary-button"
                    type="button"
                    (click)="navigateToProcessos()"
                  >
                    PESQUISAR PROCESSO AGORA
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="numbers-container">
        <div class="first-block">
          <p class="first-lane">+300</p>
          <p class="second-lane">Vencedores por dia</p>
        </div>
        <div class="second-block">
          <p class="first-lane">+350</p>
          <p class="second-lane">Novos processos</p>
        </div>
        <div class="third-block">
          <p class="first-lane">+<span>R$</span>5BI</p>
          <p class="second-lane">Transacionados por mês</p>
        </div>
        <div class="forty-block">
          <p class="first-lane">+<span>R$</span>100BI</p>
          <p class="second-lane">Transacionados em 2022</p>
        </div>
      </div>
    </div>
  </div>
  <!-- END HOME -->
  <div>
    <app-facilidades></app-facilidades>
    <app-comofunciona></app-comofunciona>
    <app-opcp></app-opcp>
    <app-footer></app-footer>
    <app-switcher></app-switcher>
  </div>
</div>
